import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class DateValidator {
	/**
	 * Kompakter Validator für beide Datumsfelder und Cross-Validierung
	 */
	static dateRangeValidator(isUnlimitedFn: () => boolean): ValidatorFn {
		return (formGroup: AbstractControl): ValidationErrors | null => {
			const validFrom = formGroup.get('validFrom')?.value;
			const validTo = formGroup.get('validTo')?.value;

			if (!validFrom) return null;

			const startDate = new Date(validFrom);
			const endDate = validTo ? new Date(validTo) : null;
			const maxDate = new Date();
			maxDate.setFullYear(maxDate.getFullYear() + 30);

			const errors: any = {};

			// Startdatum max 30 Jahre
			if (startDate > maxDate) {
				errors.message = 'errors.tooFar';
			}

			if (endDate && !isUnlimitedFn()) {
				// Enddatum max 30 Jahre
				if (endDate > maxDate) {
					errors.message = 'errors.tooFar';
				}

				// Enddatum nach Startdatum
				if (endDate <= startDate) {
					errors.message = 'errors.toDateBeforeFromDate';
				}

				// Mindestens 1 Tag Unterschied
				const nextDay = new Date(startDate);
				nextDay.setDate(startDate.getDate() + 1);
				if (endDate < nextDay) {
					errors.message = 'errors.minOneDayDiff';
				}
			}

			return Object.keys(errors).length ? errors : null;
		};
	}
}
